import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyUsers } from "../../api/apiUsers";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للمستخدمين (soft delete)
 */
export function useDeleteAllUsers() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllUsersMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyUsers,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete users");
        },
    });

    return {
        deleteAllUsersMutate,
        isPending,
    };
}